<script>
  // @ts-check
  import Rule from "../../atoms/Rule.svelte";
  import Image from "../../atoms/Image.svelte";
  import { getTheme } from "../../utilities/themes.js";
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Types from "../../organisms/GlobalNavigation/globalNavigationTypes.js";
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Themes from "../../utilities/themes.js";

  import Link from "../../atoms/Link.svelte";

  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /** @type {string}*/
  export let containerClass = "";

  /** @type {string}*/
  export let labelClass = "";

  /** @type {Types.CardContent} */
  export let cardContent;

  /** @type {boolean} */
  export let showRule = true;

  /** @type {boolean} */
  export let showLinkIcon = false;

  /**
   * @type {Themes.ThemeName}
   */
  export let theme = "lightGrey";

  $: currentTheme = getTheme(theme);

  let isLinkHovered = false;
</script>

{#if cardContent}
  <a
    data-sveltekit-reload
    {id}
    href={cardContent.linkUrl}
    class="group focus-visible:outline-dashed focus-visible:outline-offset-4
    {currentTheme.focusOutlineColor} {currentTheme.focusTextColor}
    {currentTheme.hoverTextColor}
    {currentTheme.textColor}
    {containerClass}"
    target={cardContent.isExternal ? "_blank" : null}
    rel={cardContent.isExternal ? "noopener noreferrer" : null}
    on:mouseenter={() => (isLinkHovered = true)}
    on:mouseleave={() => (isLinkHovered = false)}
  >
    {#if showRule}
      <Rule type="thin" {theme} class="mb-4" />
    {/if}
    <Image
      src={cardContent.imageUrl}
      srcset={cardContent.srcset}
      sizes={cardContent.sizes}
      aspectRatioClasses="aspect-3/2"
      elementClass="group-hover:scale-[105%] transition"
      containerClass="overflow-hidden"
      alt={cardContent.alt}
    />
    <p class="cta-md mt-2 {labelClass}">
      {#if showLinkIcon}
        <Link
          href={cardContent?.linkUrl}
          label={cardContent?.label}
          variant="small"
          isExternal={cardContent?.isExternal}
          {theme}
          {isLinkHovered}
        />
      {:else}
        {cardContent.label}
      {/if}
    </p>
  </a>
{/if}
